/* eslint-disable eqeqeq */
import {
  Spin,
  Modal,
  Select,
  Form,
  Input,
  message,
  DatePicker,
  ConfigProvider,
} from "antd";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SingleLoanServices from "services/services/SingleLoanServices";
import { convertToObjectKeyString } from "Utils/Common";
import "./LoanOfferComparison.scss";
import { FormOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { useIntl } from "react-intl";
import {
  PaymentMethodOptions,
  ReferenceRateBaseOptions,
} from "constants/Constants";
import moment from "moment";
import UserService from "services/UserService";
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import "moment/locale/fi";
import fi_translation from "locale/fi";
import en_translation from "locale/en";
import LoanOfferComparisonOtherTerms from "./LoanOfferComparisonOtherTerms";
import { useParams } from "react-router";
import LoanOfferComparisonTextarea from "./LoanOfferComparisonTextarea";

const LoanOfferComparison = (props: any) => {
  const [form] = Form.useForm();
  const intl = useIntl();
  const [loading, setLoading] = useState<boolean>(false);
  const [allBanks, setAllBanks] = useState<any>([]);
  const [recommendation, setRecommendation] = useState<any>([]);
  const [bankSaving, setBankSaving] = useState<any>("0,00");
  const [bankName, setBankName] = useState<any>(null);
  const [loanData, setLoanData] = useState<any>();
  const [saveData, setSaveData] = useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fileData, setFileData] = useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [bankList, setBankList] = useState<any>();
  const [referenceRateModalOpen, setReferenceRateModalOpen] =
    useState<any>(false);
  const [sanctionOpen, setSanctionOpen] = useState<any>(false);
  const dateFormat: any = "DD.MM.YYYY";
  const userRole = UserService?.hasRole(["app-moderator"]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [texttextSize, setTableTextSize] = useState<any>("cu-text-smaller");
  const showbtn = searchParams.get("showbtn");
  const [loanTimeOpen, setLoanTimeOpen] = useState<any>(false);
  const [recommendError, setRecommendError] = useState("");
  const [rowErrors, setRowErrors] = useState<{ [key: string]: string }>({}); //For textarea validation
  const [shareholderErrors, setShareholderErrors] = useState<{
    [key: string]: string;
  }>({});
  const [paymentErrors, setPaymentErrors] = useState<{ [key: string]: string }>(
    {},
  );
  const [otherErrors, setOtherErrors] = useState<{ [key: string]: string }>({});

  const LocaleFI: any = {
    fi: fi_translation,
  };
  const LocaleEN: any = {
    en: en_translation,
  };
  const params = useParams();

  useEffect(() => {
    getLoanData();
    getBankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allBanks.length > 8) {
      setTableTextSize("cu-text-xx-smaller");
    } else if (allBanks.length > 6) {
      setTableTextSize("cu-text-x-smaller");
    } else {
      setTableTextSize("cu-text-smaller");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allBanks]);

  useEffect(() => {
    if (referenceRateModalOpen) {
      getRefRate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referenceRateModalOpen]);

  const TranslateString = (string: any) => {
    if (showbtn === "0") {
      let key: any = convertToObjectKeyString(string);
      let value = "";
      if (showbtn === "0") {
        value = LocaleFI["fi"][key];
      } else {
        value = LocaleEN["en"][key];
      }
      return value === key ? string : value;
    } else {
      let key = convertToObjectKeyString(string);
      let value = intl.formatMessage({ id: key });
      return value === key ? string : value;
    }
  };

  const filterByNoOffer = (data: any) => {
    let offerData = data;

    data.forEach((item: any, index: any) => {
      if (item.offer_margin === "Ei tarjousta") {
        let element = offerData.splice(index, 1)[0];
        offerData.splice(offerData.length, 0, element);
      }
    });

    offerData.sort(function (a: any, b: any) {
      return a.tender_req_status - b.tender_req_status;
    });

    offerData.forEach((item: any, index: any) => {
      if (
        item.offer_margin === "Ei tarjousta" ||
        item.offer_margin === "Ei vastausta"
      ) {
        offerData[index].offer_capital_amount = "-";
        offerData[index].loan_time = "-";
        offerData[index].bank_arrangement_fee = "-";
        offerData[index].offer_estimated_mortage_price = "-";
        offerData[index].loan_data_interest_rate_bond = "-";
        offerData[index].offer_ref_rate_base = "-";
        offerData[index].reference_rate_today = "-";
        offerData[index].number_of_annual_payments = "-";
        offerData[index].loan_data_interestrate_percent = "-";
        offerData[index].loan_transfer_saction = "-";
        offerData[index].rettas_fee = "-";
        offerData[index].current_reference_rate_percent = "-";
        offerData[index].total_costs = "-";
        offerData[index].refinancing_total_costs = "-";
        offerData[index].cost_of = "-";
        offerData[index].refining_costs_1_total_savings = "-";
        offerData[index].first_year_savings = "-";
        offerData[index].refinancing_costs_capitalised_margin_costs = "-";
        offerData[index].refinancing_costs_capitalised_1st_year_savings = "-";
        offerData[index].total_saving = "-";
        offerData[index].refinancing_costs_capitalised_total_loan = "-";
        offerData[index].refinancing_costs_capitalised_total_savings = "0";
      }
      if (item.cost_of == "0") {
        offerData[index].cost_of = "-";
      }
    });

    return offerData;
  };

  const filterByNoResponse = (data: any) => {
    let responseData: any = [];

    const result1 = data.filter((item: any) => {
      return item.offer_margin === "Ei vastausta";
    });

    const result2 = data.filter((item: any) => {
      return item.offer_margin !== "Ei vastausta";
    });

    responseData = result2.concat(result1);
    return responseData;
  };

  const getAllOffers = (id: any) => {
    let obj: any = {};
    obj.loan_credit_id = id;
    obj.tender_id = params?.loan_tender_id;
    setLoading(true);
    SingleLoanServices.getAllOffers(obj)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          setAllBanks(
            filterByNoResponse(filterByNoOffer(response?.data?.data)),
          );
          // console.log("response",response)
          setRecommendation(response?.data?.recommendation);
          response?.data?.recommendation?.length &&
            setBankSaving(response?.data?.recommendation[0].saving);
          response?.data?.recommendation?.length &&
            setBankName(response?.data?.recommendation[0].bank_name);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getLoanData = () => {
    setLoading(true);

    let paramsId = props.loan_tender_id;

    SingleLoanServices.getSingleLoanData(paramsId)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          const responseVal = response?.data?.data;
          getAllOffers(responseVal?.LOAN_DATA?.loan_data_credit_id);
          setLoanData(responseVal);
          setSaveData({
            ...saveData,
            loan_tender_id: paramsId,
            loan_credit_id: responseVal?.LOAN_DATA?.loan_data_credit_id,
            attachment_ids: responseVal?.LOAN_DATA?.LOAN_DOC,
          });
          setFileData({
            customerid: responseVal?.LOAN_DATA?.loan_data_customerid,
            creditid: responseVal?.LOAN_DATA?.loan_data_credit_id,
            loan_tender_id: paramsId,
            loanname: responseVal?.loan_data_name,
          });
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getBankData = () => {
    setLoading(true);
    let obj: any = {};
    obj.size = -1;

    SingleLoanServices.getAllBank(obj)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          setBankList(response?.data?.data);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  // const changeSaving = (value: any) => {
  //   setBankName(value);
  // };

  const handleRecommendationChange = (bankName: string) => {
    setBankName(bankName);

    // Find saving
    const recItem = recommendation.find((r: any) => r.bank_name === bankName);

    if (!recItem) return;

    setBankSaving(recItem.saving);

    const bankData = allBanks.find(
      (b: any) => b.BANK_DATA?.bank_name === bankName,
    );
    // console.log("bank:", bankData);

    if (!bankData) return;

    const payload = {
      // bank_id: bankData.BANK_DATA.bank_id,
      recommend_bank_enable: "true",
      // loan_id: bankData.loan_tender_id,
      tender_req_id: bankData.tender_req_id,
      update_by: "moderator",
    };

    //  console.log("FINAL PAYLOAD:", payload);

    updateOffer(payload);
  };

  useEffect(() => {
    if (bankName && bankSaving) {
      // eslint-disable-next-line array-callback-return
      recommendation.map((row: { saving: any; bank_name: any }) => {
        if (row.bank_name == bankName) {
          setBankSaving(row.saving);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankName]);

  const getRefRate = () => {
    setLoading(true);
    SingleLoanServices.getAllRefRate()
      .then((response: any) => {
        if (response?.data?.code === 200) {
          let checked_at = moment(
            response?.data?.data?.checked_at,
            "YYYY-MM-DD",
          ).format(dateFormat);

          form.setFieldValue(
            "euribor_3kk",
            response?.data?.data?.euribor_3kk?.replace(".", ","),
          );
          form.setFieldValue(
            "euribor_6kk",
            response?.data?.data?.euribor_6kk?.replace(".", ","),
          );
          form.setFieldValue(
            "euribor_12kk",
            response?.data?.data?.euribor_12kk?.replace(".", ","),
          );
          form.setFieldValue("checked_at", moment(checked_at, "DD.MM.YYYY"));
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onLoanOfferComparisonFormSubmit = (formData: any) => {
    Modal.confirm({
      title: intl.formatMessage({
        id: convertToObjectKeyString(
          "Are you sure you want to update reference rate ?",
        ),
      }),
      icon: <ExclamationCircleFilled />,
      // content: 'Some descriptions',
      okText: intl.formatMessage({ id: convertToObjectKeyString("Yes") }),
      okButtonProps: { className: "cu-btn-green" },
      cancelText: intl.formatMessage({
        id: convertToObjectKeyString("Cancel"),
      }),
      cancelButtonProps: { className: "cu-border-green cu-text-green" },
      onOk() {
        formData.euribor_3kk = Number(formData?.euribor_3kk?.replace(",", "."));
        formData.euribor_6kk = Number(formData?.euribor_6kk?.replace(",", "."));
        formData.euribor_12kk = Number(
          formData?.euribor_12kk?.replace(",", "."),
        );
        formData["checked_at"] = moment(
          formData["checked_at"],
          "DD.MM.YYYY",
        ).format("YYYY-MM-DD");
        setLoading(true);
        SingleLoanServices.updateRefRate(formData)
          .then((response: any) => {
            if (response?.data?.code === 200) {
              message.success(
                intl.formatMessage({
                  id: convertToObjectKeyString("updated successfully"),
                }),
              );
              getLoanData();
              getBankData();
            } else if (response?.data?.code === 500) {
              message.error(
                intl.formatMessage({
                  id: convertToObjectKeyString(response?.data?.msg),
                }),
              );
            }
            setLoading(false);
            setReferenceRateModalOpen(false);
          })
          .catch((err: any) => {
            console.log(err);
            setLoading(false);
          });
      },
    });
  };

  const updateRecommendedText = (formData: any) => {
    let loan_tender_id = formData["loan_tender_id"];
    delete formData["loan_tender_id"];
    setLoading(true);
    SingleLoanServices.updateRecommendedText(formData, loan_tender_id)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("updated successfully"),
            }),
          );
          getLoanData();
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString(response?.data?.msg),
            }),
          );
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const updateOffer = (formData: any) => {
    let tender_req_id = formData["tender_req_id"];
    delete formData["loan_tender_id"];
    formData.update_by = "moderator";

    setLoading(true);
    SingleLoanServices.updateOffer(formData, tender_req_id)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("updated successfully"),
            }),
          );
          getBankData();
          getAllOffers(loanData?.LOAN_DATA?.loan_data_credit_id);
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString("tender_deadline_is_passed"),
            }),
          );
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const updateSanction = (formData: any) => {
    let loan_tender_id = props?.loan_tender_id;
    formData.loan_tender_sanction = Number(
      formData?.loan_tender_sanction?.replace(",", "."),
    );
    setLoading(true);
    SingleLoanServices.updateSanction(formData, loan_tender_id)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("updated successfully"),
            }),
          );
          getLoanData();
          getBankData();
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString(response?.data?.msg),
            }),
          );
        }
        setLoading(false);
        setSanctionOpen(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const updateLoanTime = (formVal: any) => {
    let loan_tender_id = props?.loan_tender_id;
    formVal.loan_tender_time = Number(formVal?.loan_time?.replace(",", "."));
    const { loan_time, ...formData } = formVal;

    setLoading(true);
    SingleLoanServices.updateSanction(formData, loan_tender_id)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("updated successfully"),
            }),
          );
          getLoanData();
          getBankData();
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString(response?.data?.msg),
            }),
          );
        }
        setLoading(false);
        setLoanTimeOpen(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  const resetLoanTime = (formVal: any) => {
    let formData: any = {};
    let loan_tender_id = props?.loan_tender_id;
    formData.loan_tender_time = null;
    setLoanTimeOpen(false);
    setLoading(true);
    SingleLoanServices.updateSanction(formData, loan_tender_id)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("updated successfully"),
            }),
          );
          getLoanData();
          getBankData();
        } else if (response?.data?.code === 500) {
          message.error(
            intl.formatMessage({
              id: convertToObjectKeyString(response?.data?.msg),
            }),
          );
        }
        setLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="mt-1">
          <div
            className={
              "ant-btn cu-border-0 h4 pl-0 align-middle mb-1 text-left w-100" +
              (!props?.printBtn ? " d-none" : "")
            }
          >
            {TranslateString("loan_comparison")}:{" "}
            {props?.headerText?.replace(
              "Uusi laina:",
              TranslateString("new_loan"),
            )}
          </div>
          <table
            className={
              props?.printShow || showbtn === "0"
                ? `${texttextSize} table table-xs table-bordered`
                : "table table-sm table-bordered cu-text-small"
            }
            style={{ width: "100%" }}
          >
            <thead>
              <tr>
                <th className="cu-table-row2"></th>
                <th
                  className={
                    props?.printShow || showbtn === "0"
                      ? `${texttextSize} cu-bg-lightorange3 text-dark text-left text-nowrap`
                      : "cu-bg-lightorange3 text-dark text-left cu-text-small text-nowrap"
                  }
                >
                  {TranslateString("Current loan terms")}
                </th>
                {allBanks.length > 0 ? (
                  <th
                    className={
                      props?.printShow || showbtn === "0"
                        ? `${texttextSize} cu-table-row2 text-left`
                        : "cu-table-row2 text-left cu-text-small"
                    }
                    colSpan={allBanks.length}
                  >
                    {TranslateString("Offers")}
                  </th>
                ) : (
                  ""
                )}
              </tr>
              <tr className="cu-bg-subgreen align-top">
                <th style={{ width: "20%" }} scope="col" className="text-left">
                  {TranslateString("bank_pdf")}
                </th>
                <th
                  style={{ width: 80 / (allBanks?.length + 1) + "%" }}
                  className="text-right"
                >
                  {loanData?.LOAN_DATA?.loan_data_bank_group}
                </th>
                {allBanks?.map((element: any, index: any) => {
                  return (
                    <th
                      style={{ width: 80 / (allBanks?.length + 1) + "%" }}
                      className="text-right "
                      key={index + Math.random()}
                    >
                      {userRole ? (
                        <Link
                          to={`/single-loan-view-moderator-form/${element?.tender_req_id}`}
                          className="text-white text-nowrap"
                        >
                          {element?.BANK_DATA?.bank_name}&nbsp;
                        </Link>
                      ) : (
                        element?.BANK_DATA?.bank_name
                      )}{" "}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {
                <>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Loan amount")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.loan_data_agreement.replace(
                        "€",
                        "",
                      )}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.offer_capital_amount.replace("€", "") ||
                            "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">{TranslateString("Margin")}</td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.loan_data_margin}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.offer_margin || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Loan time")}&nbsp;
                      {userRole && (
                        <FormOutlined
                          className={
                            "btn btn-sm rounded-0 p-0" +
                            (props?.printBtn ? " d-none" : "")
                          }
                          onClick={() => {
                            setLoanTimeOpen(true);
                          }}
                        />
                      )}
                    </td>
                    <td
                      className={
                        loanData?.loan_tender_time
                          ? props?.printBtn || showbtn === "0"
                            ? ` cu-bg-lightorange3 text-dark text-right`
                            : `cu-bg-lightgreen4 text-right`
                          : `cu-bg-lightorange3 text-dark text-right`
                      }
                    >
                      {/* {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.loan_time} */}
                      {loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.loan_time}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td
                          className={
                            "text-right " +
                            (element?.offer_span_year_modified == null ||
                            element?.offer_span_year_modified.trim() == "" ||
                            props?.printShow ||
                            showbtn === "0"
                              ? ""
                              : userRole
                                ? "cu-bg-lightgreen4"
                                : "")
                          }
                          key={index + Math.random()}
                        >
                          {element?.loan_time || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Repayment method")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.repayment_method}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.repayment_method || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Number of yearly payment")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.number_of_annual_payments || "-"}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.number_of_annual_payments || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Loan transfer sanction %")}&nbsp;
                      {userRole && (
                        <FormOutlined
                          style={{ fontSize: "10px" }}
                          className={
                            "btn btn-sm rounded-0 p-0" +
                            (props?.printBtn || showbtn === "0"
                              ? " d-none"
                              : "")
                          }
                          onClick={() => {
                            setSanctionOpen(true);
                          }}
                        />
                      )}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.loan_data_interestrate_percent ||
                          "-"}
                    </td>
                    {allBanks?.map((index: any) => {
                      return (
                        <td
                          className="text-right "
                          key={index + Math.random()}
                        ></td>
                      );
                    })}
                  </tr>
                  {/* <tr className='text-left border-white'><td colSpan={allBanks?.length+2}>&nbsp;</td></tr> */}
                  <tr
                    className="text-left border-white fw-bold"
                    key={Math.random()}
                  >
                    <td>{""}</td>
                    <th colSpan={allBanks?.length + 1}>
                      {TranslateString("Loan tendering costs")}
                    </th>
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Banks arrangement fee €")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.bank_arrangement_fee || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Loan transfer sanction €")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.loan_transfer_saction || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Estimated price of mortage transfer")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.offer_estimated_mortage_price || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("rettas_fee_vat_24")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.rettas_fee || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left highlight-loan-total"
                    key={Math.random()}
                  >
                    <td className="fw-bold">
                      {TranslateString("total_costs2")} €
                    </td>
                    <td className="text-dark text-right">{""}</td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td
                          className="text-right fw-bold"
                          key={index + Math.random()}
                        >
                          {element?.total_costs || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left border-white fw-bold"
                    key={Math.random()}
                  >
                    <td>{""}</td>
                    <th colSpan={allBanks?.length + 1}>
                      {TranslateString(
                        "Costs or savings related to reference rate check",
                      )}
                    </th>
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold text-nowrap">
                      {TranslateString("Current reference rate of the loan %")}
                    </td>
                    <td className="p-0 h-100">
                      <div
                        className={`text-right cu-bg-lightorange3 py-1 text-dark`}
                      >
                        {loanData?.LOAN_DATA?.loan_data_info ===
                          "internal_new" ||
                        loanData?.LOAN_DATA?.loan_data_info === "external_new"
                          ? "-"
                          : loanData?.LOAN_DATA?.current_reference_rate_percent}
                        &nbsp;
                      </div>
                    </td>
                    <td className="p-0 h-100" colSpan={allBanks.length}></td>
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    {/* <td className="fw-bold">&nbsp;{TranslateString("Time remaining to reference rate check (months)")}</td> */}
                    <td className="fw-bold">
                      {TranslateString("next_reference_data_check")}
                    </td>
                    <td className="p-0 h-100">
                      <div
                        className={`text-right cu-bg-lightorange3 py-1 text-dark`}
                      >
                        {loanData?.LOAN_DATA?.loan_data_info ===
                          "internal_new" ||
                        loanData?.LOAN_DATA?.loan_data_info === "external_new"
                          ? "-"
                          : loanData?.LOAN_DATA?.next_reference_check_date.replace(
                              "(",
                              " (",
                            ) || "-"}
                      </div>
                    </td>
                    <td className="p-0 h-100" colSpan={allBanks.length}></td>
                  </tr>
                  {/* <tr className='text-left border-white fw-bold' key={Math.random()}>
                                    <th colSpan={allBanks?.length+2}></th>
                                </tr> */}
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Reference rate")}&nbsp;
                      {userRole && (
                        <FormOutlined
                          style={{ fontSize: "10px" }}
                          className={
                            "btn btn-sm rounded-0 p-0" +
                            (props?.printBtn || showbtn === "0"
                              ? " d-none"
                              : "")
                          }
                          onClick={() => {
                            setReferenceRateModalOpen(true);
                          }}
                        />
                      )}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.loan_data_interest_rate_bond || "-"}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.offer_ref_rate_base || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Reference rate today")}&nbsp;(
                      {loanData?.LOAN_DATA?.reference_rate_changed_date})
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.reference_rate_today || "-"}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {element?.reference_rate_today || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left highlight-loan-total"
                    key={Math.random()}
                  >
                    <td className="fw-bold text-nowrap">
                      {TranslateString(
                        "Cost/profit of reference rate change €",
                      )}
                    </td>
                    <td className="text-dark text-right fw-bold"></td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td
                          className="text-right fw-bold"
                          key={index + Math.random()}
                        >
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.cost_of || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  {/* <tr className='text-left border-0' key={Math.random()}>
                                    <td className={`text-danger py-0 border-0`}>{"Arvio pankin uudelleenrahoituskuluista €"}</td>
                                    <td className={`py-0 border-0`} colSpan={allBanks.length}>{"\"Disclaimer about possible other costs\""}</td>
                                </tr>
                                <tr className='text-left border-white' key={Math.random()}>
                                    <td className={`py-0 border-0`} colSpan={allBanks?.length+1}>
                                        Finland's Bank - daily Euribor rates
                                    </td>
                                </tr> */}
                  <tr className="text-left border-white" key={Math.random()}>
                    <th></th>
                    <th
                      colSpan={allBanks?.length + 1}
                      className={`py-0 border-0`}
                    >
                      {TranslateString("Loan cost comparison and savings")}
                    </th>
                  </tr>
                  <tr
                    className="text-left border-white cu-text-smaller"
                    key={Math.random()}
                  >
                    <th></th>
                    <th colSpan={allBanks?.length + 1}>
                      {TranslateString(
                        "1. Refinancing costs covered with income financing",
                      )}
                    </th>
                  </tr>
                  {/* <tr className='text-left border-white' key={Math.random()}>
                                    <th></th>
                                    <td colSpan={allBanks?.length+1} className={`py-0 border-0 cu-text-smaller`}>
                                        {TranslateString("Mikäli järjestelypalkkiot maksetaan tulorahoituksella ja lainapääoma pidetään samana, ei tarvita yhtiökokousta. Laskennassa pankin jälleenrahoituskustannukset on jyvitetty tasaisesti lyhennysjaksoille ja Adorin palkkio maksetaan ensimmäisen vuoden aikana.")}
                                    </td>
                                </tr> */}
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Total costs")} €
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.refinancing_total_costs}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right" key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.refinancing_total_costs || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("1st year savings")} €
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.first_year_savings || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left highlight-loan-total"
                    key={Math.random()}
                  >
                    <td className="fw-bold">
                      {TranslateString("Total Savings")} €
                    </td>
                    <td className="text-dark text-right fw-bold">{""}</td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td
                          className="text-right fw-bold"
                          key={index + Math.random()}
                        >
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.refining_costs_1_total_savings || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left border-white cu-text-smaller"
                    key={Math.random()}
                  >
                    <th></th>
                    <th
                      colSpan={allBanks?.length + 1}
                      style={{ lineHeight: "12px" }}
                    >
                      {TranslateString("2. Refinancing costs capitalised")}
                    </th>
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Total loan (incl. refinancing costs)")}
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right ">
                      {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA?.refinancing_costs_capitalised_total_loan.replace(
                            "€",
                            "",
                          )}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.refinancing_costs_capitalised_total_loan.replace(
                                "€",
                                "",
                              ) || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("Total costs")} €
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right ">
                      {loanData?.LOAN_DATA?.loan_data_info === "internal_new" ||
                      loanData?.LOAN_DATA?.loan_data_info === "external_new"
                        ? "-"
                        : loanData?.LOAN_DATA
                            ?.refinancing_costs_capitalised_margin_costs}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.refinancing_costs_capitalised_margin_costs ||
                              "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td className="fw-bold">
                      {TranslateString("1st year savings")} €
                    </td>
                    <td className="cu-bg-lightorange3 text-dark text-right">
                      {""}
                    </td>
                    {allBanks?.map((element: any, index: any) => {
                      return (
                        <td className="text-right " key={index + Math.random()}>
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : element?.refinancing_costs_capitalised_1st_year_savings ||
                              "-"}
                        </td>
                      );
                    })}
                  </tr>
                  <tr
                    className="text-left highlight-loan-total"
                    key={Math.random()}
                  >
                    <td className="fw-bold">
                      {TranslateString("Total savings")} €
                    </td>
                    <td className="text-dark text-right fw-bold">{""}</td>
                    {allBanks?.map((element: any, index: any) => {
                      let total_saving =
                        element?.refinancing_costs_capitalised_total_savings;
                      if (total_saving && total_saving === "0") {
                        total_saving = "-";
                      }
                      return (
                        <td
                          className="text-right fw-bold"
                          key={index + Math.random()}
                        >
                          {loanData?.LOAN_DATA?.loan_data_info ===
                            "internal_new" ||
                          loanData?.LOAN_DATA?.loan_data_info === "external_new"
                            ? "-"
                            : total_saving || "-"}
                        </td>
                      );
                    })}
                  </tr>
                  {/* <tr className='text-left border-0' key={Math.random()}>
                                    <td className={`text-danger py-0 border-0`}></td>
                                    <td className={`py-0 border-0 cu-text-smaller`} colSpan={allBanks.length+1}>{"Säästöissä on huomioitu muutos lainakustannuksissa, jälleenrahoituskustannukset, Adorin veloittama järjestelypalkkio sekä viitekoron tarkistukseen liittyvät kustannukset/säästöt /Savings include change in loan costs, refinancing costs, Retta's arrangement fee and costs/savings related to reference rate check."}</td>
                                </tr> */}
                  <tr className="text-left border-bottom-0">
                    <th colSpan={allBanks?.length + 2}></th>
                  </tr>
                  <tr className="text-left border-white" key={Math.random()}>
                    <th></th>
                    <th
                      colSpan={allBanks?.length + 1}
                      className={`py-0 border-0`}
                    >
                      {TranslateString("Recommendation")}
                    </th>
                  </tr>
                  <tr
                    className="text-center border-white p-0 cu-table-row2"
                    key={Math.random()}
                  >
                    <td className="align-bottom fw-bold">
                      <div className="d-flex jutify-content-end">
                        {TranslateString("Total savings")} €
                      </div>
                    </td>
                    <td
                      className={`py-0 px-0 border-0 p-0`}
                      colSpan={allBanks?.length + 1}
                    >
                      <div className="cu-max-width-150 p-0">
                        <Select
                          size={"small"}
                          className={
                            props?.printShow || showbtn === "0"
                              ? `${texttextSize}`
                              : "cu-text-small"
                          }
                          showSearch
                          style={{ width: "100%", textAlign: "left" }}
                          placeholder={TranslateString("select")}
                          // defaultValue={bankName}
                          value={bankName}
                          // onChange={(e: any) => {
                          //   changeSaving(e);
                          // }}
                          onChange={(value) =>
                            handleRecommendationChange(value)
                          }
                          disabled={!userRole || props?.tenderCase === "close"}
                          options={recommendation?.map((element: any) => {
                            return {
                              label: element?.bank_name,
                              value: element?.bank_name,
                            };
                          })}
                        />
                        <div
                          className={
                            props?.printShow || showbtn === "0"
                              ? `${texttextSize} cu-max-width-150 form-control form-control-sm form-control-sm-2 rounded-0 text-left`
                              : "cu-max-width-150 cu-text-small form-control form-control-sm form-control-sm-2 rounded-0 text-left"
                          }
                        >
                          {bankSaving}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="text-left cu-table-row2" key={Math.random()}>
                    <td></td>
                    <td className="py-0 px-0" colSpan={allBanks?.length + 1}>
                      <LoanOfferComparisonTextarea
                        name="recommended_text"
                        id=""
                        cols={30}
                        rows={3}
                        style={{ whiteSpace: "pre-line" }}
                        className={
                          props?.printShow || showbtn === "0"
                            ? `${texttextSize} form-control rounded-0`
                            : "form-control rounded-0 cu-text-small"
                        }
                        disabled={!userRole || props?.tenderCase === "close"}
                        onKeyDown={(e: any) => {
                          if (e.key === ";") {
                            e.preventDefault();
                            setRecommendError(
                              "Note: 'semicolon' is not allowed.",
                            );

                            setTimeout(() => {
                              setRecommendError("");
                            }, 3000);
                          }
                        }}
                        onBlur={(e: any) => {
                          let obj = {
                            recommended_text: e?.target?.value,
                            loan_tender_id: props?.loan_tender_id,
                          };
                          updateRecommendedText(obj);
                        }}
                        text={loanData?.recommended_text}
                        printShow={props?.printShow}
                        showbtn={showbtn}
                      />
                      {recommendError && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {recommendError}
                        </span>
                      )}
                    </td>
                  </tr>
                  {/* <tr className='text-left cu-table-row2 d-none' key={Math.random()}>
                                    <td></td>
                                    <td className="py-0 px-0" colSpan={allBanks?.length+1}>
                                        <div className={`bg-white w-100 p-2`}>
                                            <p>Moderator's recommendation for solution & other possible considerations - manual input + dynamic/selectable & static texts</p>
                                            <p></p>
                                            <p className="mb-0"><b>If bank change is recommended</b>: Pankin vaihto vaatii yhtiökokouspäätöksen.</p>
                                            <p className="mb-0"><b>If original payment method is "tasaerä" and payment method changes: </b></p>
                                            <p className="mb-0">Huomioitava, että korkojen noustessa tasaerälainojen korkoaika pitenee, kun taas tasalyhennys- ja annuiteettilainoissa maksuerän suuruus kasvaa. Lyhennystavan muutos voi siis luoda painetta korottaa rahoitusvastiketta kokonaissäästöstä huolimatta.</p>
                                            <p className="mb-0"><b>Static disclaimer at the end of each recommendation:</b></p>
                                            <p className="mb-0">Suositus perustuu taloudelliseen hyötyyn. / Recommendation is based on monetary benefits.</p>
                                        </div>
                                    </td>
                                </tr> */}
                  <tr className="text-left border-white" key={Math.random()}>
                    <th></th>
                    <th colSpan={allBanks?.length + 1}></th>
                  </tr>
                  {!props?.printShow && showbtn !== "0" ? (
                    <>
                      <tr
                        className="text-left border-white cu-bg-subgreen align-top"
                        key={Math.random()}
                      >
                        <th></th>
                        <th className={`border-0`}>
                          {TranslateString("Other terms")}
                        </th>

                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <th
                              className="text-left "
                              key={index + Math.random()}
                            >
                              {userRole == true ? (
                                <Link
                                  to={`/single-loan-view-moderator-form/${element?.tender_req_id}`}
                                  className="text-nowrap text-white"
                                >
                                  {element?.BANK_DATA?.bank_name}&nbsp;
                                </Link>
                              ) : (
                                element?.BANK_DATA?.bank_name
                              )}
                            </th>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Interest rate terms")}
                        </td>
                        <td className="p-0 border bg-white">{""}</td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                            >
                              <LoanOfferComparisonTextarea
                                cols={30}
                                rows={1}
                                // data-id={element?.tender_req_id}
                                className="form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small"
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                onBlur={(e: any) => {
                                  let obj = {
                                    interest_rate_terms: e?.target?.value,
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                                onKeyDown={(e: any) => {
                                  if (e.key === ";") {
                                    e.preventDefault();

                                    const id = element?.tender_req_id;

                                    setRowErrors((prev) => ({
                                      ...prev,
                                      [id]: "Note: 'semicolon' is not allowed.",
                                    }));

                                    setTimeout(() => {
                                      setRowErrors((prev) => ({
                                        ...prev,
                                        [id]: "",
                                      }));
                                    }, 3000);
                                  }
                                }}
                                text={
                                  element?.interest_rate_terms ||
                                  "0 % + marginaali"
                                }
                                printShow={props?.printShow}
                                showbtn={showbtn}
                              />
                              {rowErrors[element?.tender_req_id] && (
                                <span
                                  style={{ color: "red", fontSize: "10px" }}
                                >
                                  {rowErrors[element?.tender_req_id]}
                                </span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Shareholder repayments")}
                        </td>
                        <td className="p-0 border bg-white"></td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                            >
                              <LoanOfferComparisonTextarea
                                cols={30}
                                rows={5}
                                className="form-control rounded-0 cu-text-small"
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                onBlur={(e: any) => {
                                  let obj = {
                                    shareholder_repayments: e?.target?.value,
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                                onKeyDown={(e: any) => {
                                  if (e.key === ";") {
                                    e.preventDefault();

                                    const key = `${element?.tender_req_id}_shareholder`;

                                    setShareholderErrors((prev) => ({
                                      ...prev,
                                      [key]:
                                        "Note: 'semicolon' is not allowed.",
                                    }));

                                    setTimeout(() => {
                                      setShareholderErrors((prev) => ({
                                        ...prev,
                                        [key]: "",
                                      }));
                                    }, 3000);
                                  }
                                }}
                                text={
                                  element?.shareholder_repayments ||
                                  element?.BANK_DATA?.shareholder_repayments ||
                                  "-"
                                }
                                printShow={props?.printShow}
                                showbtn={showbtn}
                              />
                              {shareholderErrors[
                                `${element?.tender_req_id}_shareholder`
                              ] && (
                                <span
                                  style={{ color: "red", fontSize: "10px" }}
                                >
                                  {
                                    shareholderErrors[
                                      `${element?.tender_req_id}_shareholder`
                                    ]
                                  }
                                </span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left border-white"
                        key={Math.random()}
                      >
                        <th colSpan={allBanks?.length + 2}>&nbsp;</th>
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Optional annual repayments")}
                        </td>
                        <td className="text-left border bg-white" rowSpan={4}>
                          &nbsp;
                        </td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                              rowSpan={4}
                            >
                              <Select
                                size={"small"}
                                className="cu-text-small"
                                mode="multiple"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder={TranslateString("select")}
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                value={
                                  element?.opt_annual_repayments
                                    ? element?.opt_annual_repayments?.split(",")
                                    : []
                                }
                                onChange={(e: any) => {
                                  let obj: any = {
                                    opt_annual_repayments: e?.toString(),
                                    tender_req_id: element?.tender_req_id,
                                    opt_annual_repayments_other:
                                      element?.opt_annual_repayments_other,
                                  };
                                  if (e?.toString() === "muu") {
                                    let tempAllBanks = [];
                                    tempAllBanks = allBanks.map(
                                      (element: any, index2: any) => {
                                        if (index2 === index) {
                                          element.opt_annual_repayments =
                                            e?.toString();
                                          return element;
                                        }
                                        return element;
                                      },
                                    );
                                    setAllBanks(tempAllBanks);
                                  } else {
                                    updateOffer(obj);
                                  }
                                }}
                                options={[
                                  { value: 12, label: 12 },
                                  { value: 4, label: 4 },
                                  { value: 2, label: 2 },
                                  { value: 1, label: 1 },
                                  {
                                    value: "muu",
                                    label: TranslateString("Other"),
                                  },
                                ]}
                              />
                              <LoanOfferComparisonTextarea
                                rows={3}
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                className={
                                  element?.opt_annual_repayments
                                    ?.split(",")
                                    ?.filter((f: any) => f === "muu")
                                    ?.length === 1
                                    ? "form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small"
                                    : "form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small d-none"
                                }
                                // className="form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small"
                                onBlur={(e: any) => {
                                  let obj = {
                                    opt_annual_repayments:
                                      element?.opt_annual_repayments,
                                    opt_annual_repayments_other:
                                      e?.target?.value,
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                                text={
                                  element?.opt_annual_repayments_other || ""
                                }
                                printShow={props?.printShow}
                                showbtn={showbtn}
                              />
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Optional repayment method")}
                        </td>
                        <td className="text-left border bg-white" rowSpan={3}>
                          &nbsp;
                        </td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                              rowSpan={3}
                            >
                              <Select
                                size={"small"}
                                mode="multiple"
                                className="cu-text-small"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder={TranslateString("select")}
                                options={PaymentMethodOptions}
                                value={
                                  element?.opt_repayment_method?.length
                                    ? element?.opt_repayment_method?.split(",")
                                    : element?.offer_payment_method?.length
                                      ? element?.offer_payment_method
                                      : []
                                }
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                onChange={(value: any) => {
                                  let obj = {
                                    opt_repayment_method: value?.toString(),
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                              />
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Viitekoron vaihtoehto")}
                        </td>
                        <td
                          className="text-left border bg-white p-0"
                          rowSpan={3}
                        ></td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                              rowSpan={3}
                            >
                              <Select
                                size={"small"}
                                mode="multiple"
                                allowClear
                                className="cu-text-small"
                                style={{ width: "100%" }}
                                placeholder={TranslateString("select")}
                                options={ReferenceRateBaseOptions}
                                value={
                                  element?.opt_reference_rate?.length
                                    ? element?.opt_reference_rate?.split(",")
                                    : element?.offer_ref_rate_base_other_term
                                          ?.length
                                      ? element?.offer_ref_rate_base_other_term
                                      : []
                                }
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                onChange={(e: any) => {
                                  let obj = {
                                    opt_reference_rate: e?.toString(),
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                              />
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        {/* <td>&nbsp;</td> */}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="fw-bold">
                          {TranslateString("Payment transaction transfer")}
                        </td>
                        <td className="text-left border bg-white">&nbsp;</td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white p-0"
                              key={index + Math.random()}
                            >
                              <span className="ml-2">
                                {element?.offer_transfer_payment == "1"
                                  ? TranslateString("true")
                                  : element?.offer_transfer_payment == 0
                                    ? TranslateString("false")
                                    : "-"}
                              </span>
                              <br />
                              <LoanOfferComparisonTextarea
                                name="pay_transaction_transfer"
                                id=""
                                cols={30}
                                rows={1}
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                className="form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small"
                                onBlur={(e: any) => {
                                  let obj = {
                                    pay_transaction_transfer: e?.target?.value,
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                                onKeyDown={(e: any) => {
                                  if (e.key === ";") {
                                    e.preventDefault();

                                    const key = `${element?.tender_req_id}_payment`;

                                    setPaymentErrors((prev) => ({
                                      ...prev,
                                      [key]:
                                        "Note: 'semicolon' is not allowed.",
                                    }));

                                    setTimeout(() => {
                                      setPaymentErrors((prev) => ({
                                        ...prev,
                                        [key]: "",
                                      }));
                                    }, 3000);
                                  }
                                }}
                                text={element?.pay_transaction_transfer}
                                printShow={props?.printShow}
                                showbtn={showbtn}
                              />
                              {paymentErrors[
                                `${element?.tender_req_id}_payment`
                              ] && (
                                <span
                                  style={{ color: "red", fontSize: "10px" }}
                                >
                                  {
                                    paymentErrors[
                                      `${element?.tender_req_id}_payment`
                                    ]
                                  }
                                </span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      <tr
                        className="text-left cu-table-row2"
                        key={Math.random()}
                      >
                        <td className="cu-min-height-100 fw-bold">
                          {TranslateString("Other terms")}
                        </td>
                        <td className="text-left border bg-white">&nbsp;</td>
                        {allBanks?.map((element: any, index: any) => {
                          return (
                            <td
                              className="text-left border bg-white cu-min-height-100 p-0"
                              key={index + Math.random()}
                            >
                              <LoanOfferComparisonTextarea
                                name="other_terms"
                                id=""
                                cols={30}
                                rows={1}
                                disabled={
                                  !userRole || props?.tenderCase === "close"
                                }
                                className="form-control form-control-sm form-control-sm-2 rounded-0 cu-text-small"
                                onBlur={(e: any) => {
                                  let obj = {
                                    other_terms: e?.target?.value,
                                    tender_req_id: element?.tender_req_id,
                                  };
                                  updateOffer(obj);
                                }}
                                onKeyDown={(e: any) => {
                                  if (e.key === ";") {
                                    e.preventDefault();

                                    const key = `${element?.tender_req_id}_other`;

                                    setOtherErrors((prev) => ({
                                      ...prev,
                                      [key]:
                                        "Note: 'semicolon' is not allowed.",
                                    }));

                                    setTimeout(() => {
                                      setOtherErrors((prev) => ({
                                        ...prev,
                                        [key]: "",
                                      }));
                                    }, 3000);
                                  }
                                }}
                                text={element?.other_terms}
                                printShow={props?.printShow}
                                showbtn={showbtn}
                              />
                              {otherErrors[
                                `${element?.tender_req_id}_other`
                              ] && (
                                <span
                                  style={{ color: "red", fontSize: "10px" }}
                                >
                                  {
                                    otherErrors[
                                      `${element?.tender_req_id}_other`
                                    ]
                                  }
                                </span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      {/* <tr>
                                            <th colSpan={allBanks?.length+2}>&nbsp;</th>
                                        </tr> */}
                    </>
                  ) : (
                    ""
                  )}
                </>
              }
              <tr className="border-0 page-break">
                <td colSpan={allBanks?.length + 2} className="border-0">
                  <div
                    className={
                      props?.printShow || showbtn === "0"
                        ? `${texttextSize} text-left`
                        : "text-left cu-text-small"
                    }
                    style={{ lineHeight: "14px" }}
                  >
                    <p className="mt-4">
                      Pankin veloittamat kustannukset on huomioitu säästöissä
                      jyvittämällä kulut tasaisesti lyhennysjaksoille koko
                      laina-ajalle, koska säästötkin syntyvät koko laina-ajalla.
                    </p>
                    <p>
                      Mikäli pankki vaihtuu kilpailutuksen yhteydessä, nykyinen
                      pankki voi lisäksi veloittaa jälleenrahoituskulut, jotka
                      johtuvat siitä, että pankki joutuu sijoittamaan takaisin
                      maksetun pääoman luoton koronmäääräytymisjakson
                      päättymispäivään asti alemmalla korolla kuin millä pankki
                      on jälleenrahoittanut luoton.
                    </p>
                    <p>
                      Mikäli pankki ei vaihdu, järjestelypalkkiot maksetaan
                      tulorahoituksella ja lainapääoma pidetään samana, ei
                      tarvita yhtiökokousta. Laskennassa pankin kustannukset on
                      jyvitetty tasaisesti lyhennysjaksoille ja
                      palveluntarjoajan palkkio maksetaan ensimmäisen vuoden
                      aikana.
                    </p>
                    <p>
                      Mikäli pankki vaihtuu tai kustannukset pääomitetaan,
                      vaaditaan yhtiökokouspäätös.
                    </p>
                    <p>
                      Säästöissä on huomioitu muutos marginaalikustannuksissa,
                      pankkien veloittamat kustannukset, palveluntarjoajan
                      veloittama järjestelypalkkio sekä viitekoron tarkistukseen
                      liittyvät kustannukset/säästöt seuraavaan viitekoron
                      vaihtumispäivään saakka.
                    </p>
                  </div>
                </td>
              </tr>
              {props?.printShow && showbtn === null ? (
                <LoanOfferComparisonOtherTerms
                  {...props}
                  showbtn={showbtn}
                  allBanks={allBanks}
                  userRole={userRole}
                  updateOffer={updateOffer}
                />
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </Spin>
      <Modal
        open={referenceRateModalOpen}
        title={TranslateString("Reference rate")}
        onCancel={() => setReferenceRateModalOpen(false)}
        destroyOnClose
        footer={null}
      >
        <Form
          requiredMark={false}
          form={form}
          {...{ labelCol: { span: 8 }, wrapperCol: { span: 16 } }}
          name="control-ref"
          onFinish={onLoanOfferComparisonFormSubmit}
        >
          <Form.Item
            name="euribor_3kk"
            label={
              <>
                <span>{TranslateString("3kk Euribor")}</span>
                <span className="text-danger">*</span>
              </>
            }
            rules={[
              {
                message: TranslateString("Please enter number"),
                pattern: new RegExp(/^[\d,\s]+$/),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="euribor_6kk"
            label={
              <>
                <span>{TranslateString("6kk Euribor")}</span>
                <span className="text-danger">*</span>
              </>
            }
            rules={[
              {
                message: TranslateString("Please enter number"),
                pattern: new RegExp(/^[\d,\s]+$/),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="euribor_12kk"
            label={
              <>
                <span>{TranslateString("12kk Euribor")}</span>
                <span className="text-danger">*</span>
              </>
            }
            rules={[
              {
                message: TranslateString("Please enter number"),
                pattern: new RegExp(/^[\d,\s]+$/),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <ConfigProvider locale={intl.locale === "en" ? localeEN : localeFI}>
            <Form.Item
              name="checked_at"
              label={
                <>
                  <span>{TranslateString("date")}</span>
                  <span className="text-danger">*</span>
                </>
              }
              rules={[
                {
                  message: TranslateString("select_date"),
                  required: true,
                },
              ]}
            >
              <DatePicker format={"DD.MM.YYYY"} />
            </Form.Item>
          </ConfigProvider>

          <a
            href="https://www.suomenpankki.fi/fi/Tilastot/korot/kuviot/korot_kuviot/euriborkorot_pv_chrt_fi/"
            style={{
              color: "blue",
              display: "flex",
              justifyContent: "end",
              marginBottom: "2px",
            }}
            target="_blank"
            rel="noreferrer"
          >
            <span>{TranslateString("euribor_rates_daily")}</span>
          </a>
          {/* <a href='https://www.suomenpankki.fi/fi/Tilastot/korot/kuviot/korot_kuviot/euriborkorot_pv_chrt_fi/' target="_blank"></a> */}
          <div className="d-flex justify-content-end">
            <Button
              type="reset"
              className="btn btn-sm rounded-0 bg-secondary px-4 border-secondary"
              onClick={props.handleReset}
            >
              {TranslateString("reset")}
            </Button>
            &nbsp;
            <Button
              type="submit"
              className="btn btn-sm rounded-0 cu-btn-green px-3"
              disabled={loading ? true : false}
            >
              {!loading
                ? TranslateString("Submit")
                : TranslateString("Please wait")}
            </Button>
          </div>
        </Form>
      </Modal>

      <Modal
        open={sanctionOpen}
        title={TranslateString("Loan transfer sanction %")}
        onCancel={() => setSanctionOpen(false)}
        destroyOnClose
        footer={null}
      >
        <Form requiredMark={false} name="control-ref" onFinish={updateSanction}>
          <Form.Item
            name="loan_tender_sanction"
            label={
              <>
                <span>{TranslateString("sanction_percentage")}</span>
                <span className="text-danger">*</span>
              </>
            }
            rules={[
              {
                required: true,
                message: TranslateString("Please enter number"),
                pattern: new RegExp(/^[\d,\s]+$/),
              },
            ]}
          >
            <Input min={1} max={3} />
          </Form.Item>

          <div className="d-flex justify-content-end">
            <Button
              type="reset"
              className="btn btn-sm rounded-0 bg-secondary px-4 border-secondary"
              onClick={props.handleReset}
            >
              {TranslateString("reset")}
            </Button>
            &nbsp;
            <Button
              type="submit"
              className="btn btn-sm rounded-0 cu-btn-green px-3"
              disabled={loading ? true : false}
            >
              {!loading
                ? TranslateString("Submit")
                : TranslateString("Please wait")}
            </Button>
          </div>
        </Form>
      </Modal>

      <Modal
        open={loanTimeOpen}
        title={TranslateString("loan_time")}
        onCancel={() => setLoanTimeOpen(false)}
        destroyOnClose
        footer={null}
      >
        <Form requiredMark={false} name="control-ref" onFinish={updateLoanTime}>
          <Form.Item
            name="loan_time"
            label={
              <>
                <span>{TranslateString("loan_time")}</span>
                <span className="text-danger">*</span>
              </>
            }
            rules={[
              {
                required: true,
                // message: TranslateString("Please enter number"),
                message: TranslateString(
                  "enter_numeric_digit_number_less_than_100",
                ),
                // pattern: new RegExp(/^[\d,\s]+$/),
                //  pattern: new RegExp(/^(?=.*\d)[0-9,]{1,3}$/)
                // pattern: new RegExp(/^(?:\d{1,2}|\d,\d)$/),
                //  pattern: new RegExp(/^(?:0|[1-9]\d{0,2}|1000|[1-9]\d?,\d)$/),
                //  pattern: new RegExp(/^(?:0|[1-9]\d?|[1-9]\d?,\d)$/),
                pattern: /^\d{1,2}$/,
              },
            ]}
          >
            {/* <Input min={1} max={3} /> */}
            <Input
              maxLength={2}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <div className="d-flex justify-content-end">
            <Button
              type="button"
              className="btn btn-sm rounded-0 bg-secondary px-4 border-secondary"
              onClick={resetLoanTime}
            >
              {TranslateString("reset_to_original")}
            </Button>
            &nbsp;
            <Button
              type="submit"
              className="btn btn-sm rounded-0 cu-btn-green px-3"
              disabled={loading ? true : false}
            >
              {!loading
                ? TranslateString("Submit")
                : TranslateString("Please wait")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default LoanOfferComparison;
